import { useState } from 'react';
import { SystemStatus } from '../ui/SystemStatus';
import { LastSync } from '../ui/LastSync';
import { Version } from '../ui/Version';

interface FooterProps {
  className?: string;
  sidebarWidth?: string;
}

const Footer = ({ className = '', sidebarWidth = '16rem' }: FooterProps) => {
  const [lastSyncTime, setLastSyncTime] = useState(new Date());
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setLastSyncTime(new Date());
    setIsRefreshing(false);
  };

  return (
    <footer
      className={`fixed bottom-0 right-0 z-30 bg-white border-t border-secondary-200 shadow-sm transition-all duration-300 ${className}`}
      style={{ left: `var(--sidebar-width, ${sidebarWidth})` }}
    >
      <div className="px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Left side - System status */}
          <div className="flex items-center gap-4">
            <SystemStatus status="healthy" label="System" />
            <div className="hidden sm:flex items-center gap-3">
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full" />
                <span className="text-xs text-secondary-500">API</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full" />
                <span className="text-xs text-secondary-500">DB</span>
              </div>
            </div>
          </div>

          {/* Center - Last sync (hidden on mobile) */}
          <div className="hidden md:block">
            <LastSync
              lastSyncTime={lastSyncTime}
              isLoading={isRefreshing}
              onRefresh={handleRefresh}
            />
          </div>

          {/* Right side - Version info */}
          <Version
            version="1.0.0"
            buildNumber="2024.1"
            environment={import.meta.env.MODE as 'development' | 'staging' | 'production'}
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
